import React, { useState } from "react";
import { Badge, Form, InputGroup, Button, Image } from "react-bootstrap";
import {
  FaHeart,
  FaHeartCrack,
  FaRegHeart,
  FaRegComment,
  FaEye,
  FaCommentDots,
  FaPaperPlane,
  FaRegBookmark,
  FaEllipsisVertical,
} from "react-icons/fa6";

import BirthImage from "../../../assets/Images/img (2).png";
import Dummy from "../../../assets/Images/dummy.jpeg";
import { DummyIcon, DummyImage } from "../../../components/icons/Icons";

/* ── Single Instagram-style post card ── */
const PostCard = ({ post }) => {
  const [liked, setLiked] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const caption = post.announceTypeDesc || "";
  const isLong = caption.length > 80;

  return (
    <div style={{
      background: "rgba(22,22,44,0.97)",
      border: "0.5px solid rgba(255,255,255,0.08)",
      borderRadius: "12px",
      overflow: "hidden",
      marginBottom: "24px",
      maxWidth: "480px",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
    }}>

      {/* ── Header ── */}
      <div style={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 14px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Avatar with story ring */}
          <div style={{
            width: 42, height: 42, borderRadius: "50%",
            background: "linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
            padding: "2px", flexShrink: 0,
          }}>
            <div style={{
              width: "100%", height: "100%", borderRadius: "50%",
              border: "2px solid rgba(22,22,44,0.97)",
              overflow: "hidden",
            }}>
              {post.adPhoto
                ? <img src={post.adPhoto} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                : <DummyImage class_name={"font-35 border-radius-50"} />
              }
            </div>
          </div>

          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {post.announceTypeIcon && (
                <img src={post.announceTypeIcon} style={{ width: 16, height: 16, borderRadius: "4px" }} />
              )}
              <span style={{ color: "#fff", fontWeight: 600, fontSize: "13px" }}>Jhon</span>
              <span style={{
                fontSize: "10px", padding: "1px 7px", borderRadius: "20px",
                background: "rgba(134,96,248,0.2)", color: "#c4b5fd", fontWeight: 500,
              }}>Developer</span>
            </div>
            <div style={{ color: "#6b7280", fontSize: "11px" }}>5 minutes ago</div>
          </div>
        </div>

        {/* Three dots */}
        <button style={{ background: "none", border: "none", color: "#9ca3af", cursor: "pointer", padding: "4px" }}>
          <FaEllipsisVertical style={{ fontSize: 16 }} />
        </button>
      </div>

      {/* ── Full-width image ── */}
      <div style={{ width: "100%", aspectRatio: "1 / 1", overflow: "hidden" }}>
        <img
          src={post.adPhoto || Dummy}
          alt="post"
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      </div>

      {/* ── Action icons row ── */}
      <div style={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 14px 6px",
      }}>
        {/* Left icons */}
        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Like */}
          <button
            onClick={() => setLiked(p => !p)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 1 }}
          >
            <FaHeart style={{ fontSize: 24, color: liked ? "#f43f5e" : "#9ca3af", transition: "color 0.2s" }} />
          </button>

          {/* Comment */}
          <button style={{ background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 1 }}>
            <FaRegComment style={{ fontSize: 23, color: "#9ca3af" }} />
          </button>

          {/* Share / paper plane */}
          <button style={{ background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 1 }}>
            <FaPaperPlane style={{ fontSize: 21, color: "#9ca3af" }} />
          </button>

          {/* Views */}
          <span style={{ color: "#6b7280", fontSize: "12px", display: "flex", alignItems: "center", gap: "4px" }}>
            <FaEye style={{ fontSize: 15 }} /> 0
          </span>
        </div>

        {/* Bookmark */}
        <button
          onClick={() => setBookmarked(p => !p)}
          style={{ background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 1 }}
        >
          <FaRegBookmark style={{ fontSize: 22, color: bookmarked ? "#8660F8" : "#9ca3af", transition: "color 0.2s" }} />
        </button>
      </div>

      {/* ── Likes count ── */}
      <div style={{ padding: "0 14px 6px" }}>
        <span style={{ color: "#fff", fontSize: "13px", fontWeight: 600 }}>
          {liked ? 1 : 0} likes
        </span>
      </div>

      {/* ── Caption ── */}
      <div style={{ padding: "0 14px 10px" }}>
        <span style={{ color: "#fff", fontWeight: 600, fontSize: "13px", marginRight: "6px" }}>Jhon</span>
        <span style={{ color: "#d1d5db", fontSize: "13px" }}>
          🎂 {post.subject} — {expanded || !isLong ? caption : caption.slice(0, 80) + "…"}
        </span>
        {isLong && (
          <span
            onClick={() => setExpanded(p => !p)}
            style={{ color: "#6b7280", fontSize: "13px", cursor: "pointer", marginLeft: "4px" }}
          >
            {expanded ? " less" : " more"}
          </span>
        )}
        <div style={{ fontSize: "18px", marginTop: "4px" }}>✨</div>
      </div>

      {/* ── Reactions row (your existing stats) ── */}
      <div style={{
        display: "flex", gap: "14px", padding: "0 14px 10px",
        borderTop: "0.5px solid rgba(255,255,255,0.06)", paddingTop: "8px",
      }}>
        <span style={{ color: "#4ade80", display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
          <FaHeart /> 0
        </span>
        <span style={{ color: "#f87171", display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
          <FaHeartCrack /> 0
        </span>
        <span style={{ color: "#60a5fa", display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
          <FaCommentDots /> 0
        </span>
      </div>

      {/* ── Comment Input ── */}
      <div style={{
        display: "flex", alignItems: "center", gap: "10px",
        padding: "8px 14px 12px",
        borderTop: "0.5px solid rgba(255,255,255,0.06)",
      }}>
        <div style={{
          width: 28, height: 28, borderRadius: "50%", overflow: "hidden", flexShrink: 0,
          background: "rgba(255,255,255,0.08)",
        }}>
          <img src={BirthImage} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
        <InputGroup style={{ flex: 1 }}>
          <Form.Control
            placeholder="Write a birthday wish..."
            className="comment-input universal-input"
            style={{ fontSize: "12px", background: "transparent", border: "none", color: "#9ca3af", padding: "0 4px" }}
          />
          <Button variant="link" className="send-btn" style={{ padding: 0 }}>
            <FaPaperPlane style={{ color: "#8660F8", fontSize: 15 }} />
          </Button>
        </InputGroup>
      </div>

    </div>
  );
};

/* ── Main export ── */
const MainContent = ({ socialData }) => {
  return (
    <div className="main-content-hub" style={{ padding: "16px 8px" }}>
      {Array.isArray(socialData) && socialData.map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
};

export default MainContent;